import { type Language } from 'src/core/config/i18n';

export const getHelpVideoUrl = (
  id: 'custom_fields' | 'expense_categories',
  activeLanguage: Language,
): string => {
  switch (id) {
    case 'custom_fields': {
      if (activeLanguage === 'de') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-analytical_fields-de.mp4';
      }
      if (activeLanguage === 'fr') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-analytical_fields-fr.mp4';
      }
      if (activeLanguage === 'es') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/Analytical+Fields+ES.mp4';
      }
      return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-analytical_fields-en.mp4';
    }
    case 'expense_categories': {
      if (activeLanguage === 'de') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-expense_categories-de.mp4';
      }
      if (activeLanguage === 'fr') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-expense_categories-fr.mp4';
      }
      if (activeLanguage === 'es') {
        return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/Expense+Categories+ES.mp4';
      }
      return 'https://spx-production.s3.eu-west-1.amazonaws.com/onboarding/videos/control_settings-expense_categories-en.mp4';
    }
    default:
      throw new Error(`Unexpected task type ${id} in Setup Hub`);
  }
};
